
<div class="modal fade" id="{{loadBankApplyFormId}}" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">

            <div class="modal-header">
                <h6 class="modal-title">{{loadBankType}} Numbers</h6>
                <button type="button" #closeButton class="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close" *ngIf="!isChildModal"></button>
                <button type="button" #closeChildButton class="btn-close btn-sm " data-bs-toggle="modal"
                        attr.data-bs-target="#{{applyParameters.parentModal}}" aria-label="Close" *ngIf="isChildModal"></button>
            </div>
            <div class="modal-body">

                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-12">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="filterCommodity" name="filterCommodity" (change)="getloadBankList()" [(ngModel)]="applyParameters.filterCommodity">
                                <label class="form-check-label form-label" for="filterCommodity">Commodity: {{applyParameters.commodityCode}}</label>
                            </div>
                            <div class="form-check form-check-inline" *ngIf="applyParameters.locationId > 0">
                                <input class="form-check-input" type="checkbox" id="filterLocation" name="filterLocation" (change)="getloadBankList()" [(ngModel)]="applyParameters.filterLocation">
                                <label class="form-check-label form-label" for="filterLocation">{{locationType}}: {{applyParameters.locationName}}</label>
                            </div>
                            <div class="form-check form-check-inline" *ngIf="applyParameters.customerId > 0">
                                <input class="form-check-input" type="checkbox" id="filterCustomer" name="filterCustomer" (change)="getloadBankList()" [(ngModel)]="applyParameters.filterCustomer">
                                <label class="form-check-label form-label" for="filterCustomer">Customer: {{applyParameters.customerName}}</label>
                            </div>
                            <div class="form-check form-check-inline" *ngIf="applyParameters.contractIds.length > 0">
                                <input class="form-check-input" type="checkbox" id="filterContract" name="filterContract" (change)="getloadBankList()" [(ngModel)]="applyParameters.filterContract">
                                <label class="form-check-label form-label" for="filterContract">Contract: {{applyParameters.contractNumber}}</label>
                            </div>
                        </div>
                    </div>

                    <div class="border border-rounded px-1 mb-2 table-responsive" [ngStyle]="isMobile ? {'width': '100%'} : {}" style="height: 400px;">
                        <table class="table table-sm table-borderless scrollable">
                            <thead>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th [ngStyle]="isMobile ? {'min-width': '65px'} : {}">{{loadBankType}} #</th>
                                    <th *ngIf="!isMobile">Description</th>
                                    <th>Comm</th>
                                    <th>{{locationType}}</th>
                                    <th>Customer</th>
                                    <th>Contract</th>
                                    <th>Ship&nbsp;From</th>
                                    <th>Ship&nbsp;To</th>
                                    <th *ngIf="!isMobile">Entered&nbsp;By</th>
                                    <th *ngIf="!isMobile">Entered&nbsp;Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of loadBankList; index as i">
                                    <td><input class="form-check-input" type="checkbox" name="select-{{item.loadBankId}}" (change)="selectLoadNumber(i)" [(ngModel)]="item.selected"></td>
                                    <td>{{item.loadNumber}}</td>
                                    <td *ngIf="!isMobile">{{item.description}}</td>
                                    <td>{{item.commodityCode}}</td>
                                    <td>{{item.locationName}}</td>
                                    <td>{{item.customerName}}</td>
                                    <td>{{item.contractNumber}}</td>
                                    <td>{{item.shipFrom}}</td>
                                    <td>{{item.shipTo}}</td>
                                    <td *ngIf="!isMobile">{{item.createdBy}}</td>
                                    <td *ngIf="!isMobile">{{item.createdDate}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="text-center text-primary" *ngIf="isLoading">
                            Loading...
                            <div class="spinner-border spinner-border-sm ms-4" role="status" aria-hidden="true"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="d-block w-100">
                    <div class="float-start text-danger" *ngIf="errorMessage.length > 0">{{errorMessage}}</div>
                    <div class="float-end" *ngIf="formStatus == FormStatus.Normal || formStatus == FormStatus.Saving">
                        <button type="button" class="btn btn-sm btn-primary me-2" style="width: 80px;" (click)="applyLoadNumbers()" *ngIf="formStatus == FormStatus.Normal">Apply</button>
                        <button type="button" class="btn btn-sm btn-primary me-2" disabled *ngIf="formStatus == FormStatus.Saving">
                            <span class="spinner-border spinner-border-sm me-1"></span>
                            <span>Saving...</span>
                        </button>
                        <button type="button" class="btn btn-sm btn-secondary" style="width: 80px;" data-bs-dismiss="modal" 
                                [disabled]="formStatus == FormStatus.Saving" *ngIf="!isChildModal">
                            Cancel
                        </button>
                        <button type="button" class="btn btn-sm btn-secondary" style="width: 80px;" data-bs-toggle="modal" 
                                attr.data-bs-target="#{{applyParameters.parentModal}}"
                                [disabled]="formStatus == FormStatus.Saving" *ngIf="isChildModal">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>